import { useContext } from "react"
import ForgotPasswordFormContext from "../context/ForgotPasswordFormContext"

const useForgotPasswordFormContext = () => {
    return useContext(ForgotPasswordFormContext)
}

export default useForgotPasswordFormContext